import NotifyMeWhenInStockModalManager from 'global/notifyMeWhenInStock/notifyMeWhenInStockModalManager';
import notifyMeWhenInStockRequest, {
	notifyMeWhenInStockSuccess,
} from 'global/notifyMeWhenInStock/notifyMeWhenInStockModal';

class NotifyMeWhenInStock {
	constructor(options = {}) {
		const parent = options.parent || document;

		this.notifyMeWhenInStockButtons = parent.querySelectorAll(
			'[data-notify-me-when-in-stock]',
		);
		this.notifyMeWhenInStockId = 'notifyMeWhenInStock';

		if (this.notifyMeWhenInStockButtons.length) {
			this.addEventListeners();
		}
	}

	addEventListeners() {
		[].forEach.call(this.notifyMeWhenInStockButtons, notifyMeButton => {
			notifyMeButton.addEventListener('click', evt =>
				this.populateNotifyMeWhenInStockModal(
					evt.target.getAttribute('data-code'),
				),
			);
		});
	}

	removeEventListeners() {
		if (this.modelSubmitButton) {
			return this.modelSubmitButton.removeEventListener(
				'click',
				this.successNotifyMeWhenInStockModal,
			);
		}
		return false;
	}

	populateNotifyMeWhenInStockModal(productCode) {
		return notifyMeWhenInStockRequest(productCode).then(result => {
			this.modalInstance = new NotifyMeWhenInStockModalManager();
			this.updateNotifyMeWhenInStockModal(result, productCode);
		});
	}

	successNotifyMeWhenInStockModal(productCode, event) {
		event.preventDefault();
		const email = document.getElementById('email').value;
		this.removeEventListeners();
		return notifyMeWhenInStockSuccess(productCode, email).then(result =>
			this.updateNotifyMeWhenInStockModal(result, productCode),
		);
	}

	updateNotifyMeWhenInStockModal(result, productCode) {
		const { data } = result;
		this.modalInstance.insertResponse(data, this.notifyMeWhenInStockId);
		this.modelSubmitButton = document.getElementById(
			'notifyMeWhenInStockModalSubmit',
		);
		if (this.modelSubmitButton) {
			return this.modelSubmitButton.addEventListener(
				'click',
				this.successNotifyMeWhenInStockModal.bind(this, productCode),
			);
		}

		return false;
	}
}

export default NotifyMeWhenInStock;
